import styled, {css} from 'styled-components';

import {
  NumberInput as BaseNumberInput,
  Radio as BaseRadio,
  NewNumberInputField,
  NewRadioField,
} from '@edna/components';
import {Label as BaseLabel} from '@edna/components/FormField';
import {mixins} from '@edna/components/styles';

import {ModalCenterImage} from 'src/components/primitives';

export const CancelChangesImage = styled(ModalCenterImage)`
  width: 142px;
  min-width: 142px;
`;
export const Label = styled(BaseLabel)`
  ${mixins.f2}
`;

export const Section = styled.div`
  width: 100%;
  ${mixins.stack({size: '4'})}
  ${({theme}) => css`
    padding: ${theme.spacing.s4};
    border: 1px solid ${theme.palette.grey200};
    border-radius: ${theme.borderRadius.br2};
  `};
`;

export const NumberInputField = styled(NewNumberInputField).attrs((props) => ({
  isDecimal: true,
  noMargin: true,
  thousandSeparator: ' ',
  ...props,
}))``;

export const NumberInput = styled(BaseNumberInput).attrs((props) => ({
  isDecimal: true,
  noMargin: true,
  thousandSeparator: ' ',
  ...props,
}))``;

export const RadioField = styled(NewRadioField)`
  width: auto;
`;

export const Radio = styled(BaseRadio)`
  width: auto;
`;

export const LeftIcon = styled.svg`
  margin-right: ${({theme}) => theme.spacing.s2};
`;

export const Link = styled.span`
  text-decoration: underline;
  color: currentColor;
  cursor: pointer;
`;
